// Composant texte tokenisé — remplace tout <p>/<span>/<h*> brut.
// La typo vient des tokens (fontStyle) ; la couleur d'une classe Tailwind tokenisée.

import type { ElementType, HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/cn';
import { fontStyle, type TypographyToken } from '@/theme/typography';

interface TextProps extends Omit<HTMLAttributes<HTMLElement>, 'style'> {
  variant?: TypographyToken;
  as?: ElementType;
  className?: string;
  children: ReactNode;
}

export function Text({ variant = 'body', as: Tag = 'p', className, children, ...rest }: TextProps) {
  return (
    <Tag {...rest} style={fontStyle(variant)} className={cn('text-text-primary', className)}>
      {children}
    </Tag>
  );
}
